module.exports = __webpack_public_path__ + "img/toyosatomimi no miko_lw.a2f52951.png";